var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlgo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 12.8903L7.06106 10.6481L8.35538 8.41388L9.64237 6.17175L9.85612 5.81625L9.95006 6.17175L10.3449 7.64775L9.90281 8.41388L8.6085 10.6481L7.3215 12.8903H8.86837L10.1633 10.6481L10.8343 9.48769L11.1504 10.6481L11.7501 12.8903H13.1394L12.5398 10.6481L11.9396 8.41388L11.7821 7.83731L12.7451 6.17175H11.34L11.2922 6.00581L10.8028 4.17431L10.7398 3.9375H9.38981L9.35831 3.98475L8.09494 6.17175L6.80006 8.41388L5.51363 10.6481L4.21875 12.8903H5.76562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgo);
export default __webpack_public_path__ + "static/media/algo.f6672a57d07018daedeb473fc6862373.svg";
export { ForwardRef as ReactComponent };